export const iosAppTypes = {
  set: 'iosApp/set',
  edit: 'iosApp/edit',
  add: 'iosApp/add',
};
